export default __webpack_public_path__ + "static/media/Negative_ Your investment not make a profit@1x.2525dba9.png";